import { render, staticRenderFns } from "./eDSPrivacy.vue?vue&type=template&id=103399cc"
import script from "./eDSPrivacy.vue?vue&type=script&lang=js"
export * from "./eDSPrivacy.vue?vue&type=script&lang=js"
import style0 from "./eDSPrivacy.vue?vue&type=style&index=0&id=103399cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports